// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"b5488f9e","684":"9bcf0f1d"}[chunkId] + ".chunk.js";
};